import cashBookInstance from '../../cashBook/instance'

const getInitialBalanceOldCashBook = () => {
	return cashBookInstance.get('/cash-book/initial-balance')
}

export default getInitialBalanceOldCashBook
